import { Component } from '@angular/core';
import { RevealDirective } from '../../core/directives/reveal.directive';
import { CountUpComponent } from '../../core/directives/count-up.component';

@Component({
  selector: 'hx-hero',
  standalone: true,
  imports: [RevealDirective, CountUpComponent],
  template: `
    <header class="hero">
      <div class="wrap">
        <div>
          <p class="eyebrow">I.T. Solutions &amp; Cloud Engineering</p>
          <h1>We build the infrastructure your business <em>runs on.</em></h1>
          <p class="hero-sub">
            Hexacorp designs, deploys, and maintains cloud platforms, payment gateway systems, and
            custom software for teams that can't afford downtime.
          </p>
          <div class="hero-actions">
            <a href="#contact" class="btn btn-primary">Start a project</a>
            <a href="#work" class="btn btn-ghost">See our work →</a>
          </div>
          <p class="hero-note">
            MULTI-CLOUD: AWS · AZURE · GCP &nbsp;·&nbsp; PAYMENT-GRADE ARCHITECTURE &nbsp;·&nbsp;
            DEDICATED DELIVERY TEAMS
          </p>
        </div>

        <div class="stats-panel reveal" appReveal>
          <div class="status-panel-head">
            <span>Track Record</span>
            <div class="status-dots"><i></i><i></i><i></i></div>
          </div>

          <div class="stat-row">
            <div class="stat-number-wrap">
              <hx-count-up [target]="100" suffix="+"></hx-count-up>
            </div>
            <div class="stat-copy">
              <span class="stat-label">Projects Delivered</span>
              <span class="stat-sub">and counting</span>
            </div>
          </div>

          <div class="stat-row">
            <div class="stat-number-wrap">
              <b class="stat-number-static">8</b>
            </div>
            <div class="stat-copy">
              <span class="stat-label">Projects Ongoing</span>
              <span class="stat-sub">across different regions &amp; industries</span>
            </div>
          </div>

          <div class="stat-row">
            <div class="stat-number-wrap">
              <hx-count-up [target]="20" suffix="+"></hx-count-up>
            </div>
            <div class="stat-copy">
              <span class="stat-label">Partners</span>
              <span class="stat-sub">and counting</span>
            </div>
          </div>

          <div class="status-panel-foot">
            <span>track record · all-time</span>
            <span>PH · EU · Global</span>
          </div>
        </div>
      </div>
    </header>
  `,
})
export class HeroComponent {}
